import { metaToConsts } from "@/shared/lib/meta-to-consts";
import { metaToMap } from "@/shared/lib/meta-to-map";
import type { ValueMeta } from "@/shared/model";

type PageErrorMeta = ValueMeta<string> & {
  description: string;
  message: string;
};

export const PAGE_ERROR_META = [
  {
    id: "PE01",
    name: "NOT_FOUND",
    label: "페이지를 찾을 수 없습니다",
    value: "NOT_FOUND",
    description: "존재하지 않는 경로 접근 (404 페이지)",
    message: "요청하신 페이지가 존재하지 않거나 삭제되었습니다.",
  },
  {
    id: "PE02",
    name: "PUBLIC_ERROR",
    label: "페이지를 불러올 수 없습니다",
    value: "PUBLIC_ERROR",
    description: "공개 페이지 라우트 그룹 에러 바운더리",
    message: "페이지를 불러오는 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
  },
  {
    id: "PE03",
    name: "PROTECTED_ERROR",
    label: "페이지를 불러올 수 없습니다",
    value: "PROTECTED_ERROR",
    description: "보호 페이지 라우트 그룹 에러 바운더리",
    message:
      "대시보드를 불러오는 중 오류가 발생했습니다. 다시 시도하거나 로그인 상태를 확인해 주세요.",
  },
  {
    id: "PE04",
    name: "CHAT_FLOW_ERROR",
    label: "대화 중 문제가 발생했습니다",
    value: "CHAT_FLOW_ERROR",
    description: "대화 흐름 라우트 그룹 에러 바운더리",
    message: "대화를 진행하는 중 오류가 발생했습니다. 다시 시도하거나 처음부터 시작해 주세요.",
  },
  {
    id: "PE05",
    name: "GLOBAL_ERROR",
    label: "앱에 문제가 발생했습니다",
    value: "GLOBAL_ERROR",
    description: "전역 에러 바운더리 (global-error.tsx)",
    message: "예상치 못한 오류가 발생했습니다. 페이지를 새로고침하거나 잠시 후 다시 시도해 주세요.",
  },
] as const satisfies readonly PageErrorMeta[];

export const PAGE_ERROR_VALUE = metaToConsts(PAGE_ERROR_META);
export const PAGE_ERROR_MAP = metaToMap(PAGE_ERROR_META);
export type PageErrorId = (typeof PAGE_ERROR_META)[number]["id"];
